// tslint:disable: max-line-length
import axios from 'axios';
import { getItem } from '../../utils/localStorage';
import {
  CreateDataByIndexedDB,
  GetAllDataByIndexedDB,
} from '../../indexed/index';
import moment from 'moment';
import { authMeRes } from '../../requests/notifications';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';

export const standard = async (
  categoryId,
  fromDate,
  hotelId,
  isSelf,
  assessmentId
) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];

  const { data } = await axiosInstance.get(
    `${
      Env.API_URL
    }/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=LQA&view=category${
      isSelf ? '&self=1&assessmentId=' + assessmentId : '&toDate=' + fromDate
    }&language=en&visit=1&categoryId=${categoryId}&isDisplayOnly=0`
  );
  dataD = data;

  return dataD;
};

export const getTemplate = async (assessmentId) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customerAssessment/${assessmentId}/template?`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customerAssessment/${assessmentId}/template?`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customerAssessment/${assessmentId}/template?`,
      data,
      selectedHotel
    );
  }

  return dataD;
};

export const getSelfAssessment = async (assessmentId) => {
  let dataD: any = [];
  const { data } = await axiosInstance.get(
    ` ${Env.API_URL}/customerAssessment/${assessmentId}?&isClientApp=true`
  );
  dataD = data;
  return dataD;
};

export const handleSubmitSelfAssessment = async (assessmentId) => {
  const response = await authMeRes();
  const { accessToken } = response.data;
  const { data } = await axios.put(
    `${Env.API_URL}/customerAssessment/submit/${assessmentId}`,
    { isSubmit: true },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const editSelfAssessment = async (assessmentId, payLoad) => {
  const response = await authMeRes();
  const { accessToken } = response.data;
  const { data } = await axios.put(
    `${Env.API_URL}/customerAssessment/${assessmentId}/?isClientApp=true`,
    payLoad,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const editSelfAssessmentWithParent = async (
  assessmentId,
  parentId,
  payLoad
) => {
  const response = await authMeRes();
  const { accessToken } = response.data;
  const { data } = await axios.put(
    `${Env.API_URL}/customerAssessment/parent/${assessmentId}/${parentId}/?isClientApp=true`,
    payLoad,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const getSelfAssessmentAttachments = async (
  assessmentId,
  selectedDepartmentId
) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/getDepartmentAttachments/${selectedDepartmentId}`
  );

  const attachments = data.map((file) => ({
    ...file,
    onRemove: () => {},
  }));
  return attachments;
};

export const uploadSelfAssessmentAttachment = async (
  assessmentId,
  departmentId,
  formData
) => {
  const userData = getItem('user');
  const { data } = await axios.post(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/attachFileToDepartment/${departmentId}`,
    formData,
    {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.accessToken}`,
      },
    }
  );

  return data;
};
export const deleteSelfAssessmentAttachment = async (
  assessmentId,
  departmentId,
  fileId,
  fileName
) => {
  const userData = getItem('user');
  const { data } = await axios.delete(
    `${
      Env.API_URL
    }/assessmentAttachment/self/${assessmentId}/removeDepartmentAttachment/${departmentId}/${fileId}?fileName=${encodeURIComponent(
      fileName
    )}`,
    {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    }
  );
  return data;
};

export const getUsers = async (text) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customerClientUser/assignees/?page=1&pageSize=100&isActive=true&sort=userLastName%2CuserFirstName&name=${text}&&selectedHotelId=${selectedHotel}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customerClientUser/assignees/?page=1&pageSize=100&isActive=true&sort=userLastName%2CuserFirstName&name=${text}&&selectedHotelId=${selectedHotel}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customerClientUser/assignees/?page=1&pageSize=100&isActive=true&sort=userLastName%2CuserFirstName&name=${text}&&selectedHotelId=${selectedHotel}&isClientApp=true`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const getUserProfile = async (userId) => {
  const { selectedHotel } = userHotelDetails();
  const apiEndpointUrl = `${Env.API_URL}/user-profile/${userId}/user/getAttachFile`;

  const indexedDbResponse: any = await GetAllDataByIndexedDB(
    apiEndpointUrl,
    selectedHotel
  );

  if (
    indexedDbResponse &&
    indexedDbResponse.expirationTime &&
    moment().isBefore(indexedDbResponse.expirationTime)
  ) {
    return indexedDbResponse.data;
  }

  const { data } = await axiosInstance.get(apiEndpointUrl);

  if (data && data[0] && data[0].url) {
    CreateDataByIndexedDB(
      apiEndpointUrl,
      {
        data,
        expirationTime: moment().add(3, 'hours').toDate(),
      },
      selectedHotel
    );
  }

  return data;
};
export const uploadSelfAssessmentAttachmentForStandard = async (
  assessmentId,
  duplicateCategoryId,
  templateStandardId,
  formData
) => {
  const userData = getItem('user');
  const { data } = await axios.post(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/attachFileToDepartment/${duplicateCategoryId}/${templateStandardId}`,
    formData,
    {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.accessToken}`,
      },
    }
  );

  return data;
};

export const getSelfAssessmentAttachmentForStandard = async (
  assessmentId,
  duplicateCategoryId,
  templateStandardId
) => {
  const userData = getItem('user');
  const { data } = await axios.get(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/getDepartmentAttachments/${duplicateCategoryId}/${templateStandardId}`,
    {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.accessToken}`,
      },
    }
  );

  return data;
};

export const deleteSelfAssessmentAttachmentForStandard = async (
  assessmentId,
  duplicateCategoryId,
  templateStandardId,
  fileId,
  fileName
) => {
  const userData = getItem('user');
  const { data } = await axios.delete(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/removeStandardAttachment/${duplicateCategoryId}/${templateStandardId}/${fileId}?fileName=${fileName}`,
    {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.accessToken}`,
      },
    }
  );

  return data;
};

export const getSelfAssessmentAttachmentsListOfStandards = async (
  assessmentId,
  duplicateCategoryId
) => {
  const userData = getItem('user');
  const { data } = await axios.get(
    `${Env.API_URL}/assessmentAttachment/self/${assessmentId}/getStandardWithAttachments/${duplicateCategoryId}`,
    {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.accessToken}`,
      },
    }
  );
  return data;
};
